import KickoutLayout from "../Layout/KickoutLayout";

export default function OnboardingPaused() {
    return (
        <KickoutLayout
            header="Onboarding Paused"
            icon="icon-alert"
        >
            <div className="container">
                <div className="margin-top row" style={{ marginTop: "60px" }}>
                    <div className="hidden-sm col-md-3">
                        <img src="images/pose.png" alt="Decorative pose" />
                    </div>
                    <div className="col-sm-12 col-md-8">
                        <div className="alert-content" style={{ marginTop: "40px" }} data-testid="onboarding-paused" role="alert" aria-live="polite">
                            <div className="h3" style={{ whiteSpace: "nowrap" }}>
                                Onboarding is temporarily paused.
                            </div>
                            <p>
                                Please contact your agency for any questions.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </KickoutLayout>
    );
}
